export { default as Img200 } from './processed/200/Mr-Robot-S3.jpg';
export { default as Img400 } from './processed/400/Mr-Robot-S3.jpg';
export { default as Imgthumb } from './processed/thumb/Mr-Robot-S3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Mr-Robot-S3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Mr-Robot-S3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      47,
      183,
      194
    ],
    "_population": 630,
    "_hsl": [
      0.5124716553287981,
      0.6099585062240663,
      0.4725490196078431
    ]
  },
  "LightVibrant": {
    "_rgb": [
      164,
      220,
      228
    ],
    "_population": 2,
    "_hsl": [
      0.5208333333333334,
      0.5423728813559322,
      0.7686274509803922
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      28,
      67,
      90
    ],
    "_population": 1142,
    "_hsl": [
      0.5618279569892474,
      0.5254237288135594,
      0.23137254901960785
    ]
  },
  "Muted": {
    "_rgb": [
      189,
      108,
      101
    ],
    "_population": 31,
    "_hsl": [
      0.013257575757575761,
      0.4,
      0.5686274509803921
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      214,
      215
    ],
    "_population": 3343,
    "_hsl": [
      0.5038759689922481,
      0.34959349593495936,
      0.7588235294117647
    ]
  },
  "DarkMuted": {
    "_rgb": [
      12,
      16,
      26
    ],
    "_population": 4326,
    "_hsl": [
      0.6190476190476191,
      0.3684210526315789,
      0.07450980392156863
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Mr-Robot-S3.js